module.exports = {
      id: "comm-children-usage",
      viewBox: "0 0 237.872 42.449",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-children",
      toString: function () {
        return this.url;
      }
    }